import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { closeModal, failedVerification, kycBajajDeepCheckAction, successVerification } from './actions';
import { ACTION } from './types';
import SharedPropsService from '../../SharedPropsService';
import { heightMap } from '../../configs/height';
export const template = (targetUrl) => ({
    layout: {
        id: ROUTE.BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL,
        type: LAYOUTS.MODAL,
        style: {
            height: heightMap[ROUTE.DIGIO_MODAL],
        },
        widgets: [
            {
                id: 'headerStack',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
                padding: {
                    right: 8,
                    top: 8,
                    bottom: 0,
                    left: 0,
                },
            },
            { id: 'bajajDigioKyc', type: WIDGET.BAJAJ_DIGIO_KYC_MODAL },
            { id: 'space', type: WIDGET.SPACE },
        ],
    },
    datastore: {
        spaceXL: { size: SizeTypeTokens.Size10 },
        headerStack: {
            type: StackType.row,
            alignItems: StackAlignItems.flexEnd,
            justifyContent: StackJustifyContent.flexEnd,
            widgetItems: [{ id: 'leadIcon', type: WIDGET.BUTTON }],
        },
        leadIcon: {
            label: '',
            type: ButtonTypeTokens.SmallGhost,
            width: ButtonWidthTypeToken.CONTENT,
            stack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
            },
            icon: {
                name: IconTokens.Cancel,
                align: IconAlignmentTokens.right,
                size: IconSizeTokens.XXXXL,
            },
            action: {
                type: ACTION.CANCEL_DIGIO,
                payload: {},
                routeId: ROUTE.BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL,
            },
        },
        bajajDigioKyc: {
            targetUrl: targetUrl,
            callBackAction: {
                routeId: ROUTE.BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL,
                type: ACTION.BAJAJ_CALL_BACK_ACTION,
                payload: {}
            }
        },
        space: {
            size: SizeTypeTokens.XL
        }
    },
});
export const bajajKycCoborrowerDigioModal = {
    onLoad: async ({ network }, { targetUrl }) => {
        const user = await SharedPropsService.getUser();
        const applicationId = user.linkedApplications[0].applicationId;
        return Promise.resolve(template(targetUrl));
    },
    actions: {
        [ACTION.CANCEL_DIGIO]: closeModal,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.BAJAJ_CALL_BACK_ACTION]: kycBajajDeepCheckAction
    },
};
